import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectPerformanceReport from '@app/views/Project/PerformaceReport';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectPerformanceReport)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
